<template>
  <b-container fluid style="height:570px; overflow-y:auto;">
    <b-spinner
      v-if="isLoading"
      type="grow"
      class="text-center"
      style="margin-top: 10%; position:absolute;"
      variant="primary"
    ></b-spinner>

    <b-navbar toggleable="lg" type="dark" variant="light">
      <b-navbar-brand href="#" class="text-dark">
        <strong>Clients</strong>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-button
              class="my-2 my-sm-0 mr-2"
              variant="outline-primary"
              size="sm"
              @click="showAddModal()"
            >
              <font-awesome-icon icon="plus" />
            </b-button>
            <b-button
              variant="outline-info"
              size="sm"
              style="margin-right:30px;"
              @click="reloadTable"
            >
              <font-awesome-icon icon="sync" />
            </b-button>
            <b-form-group
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
            >
              <b-input-group size="sm">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-row>
      <b-col cols="12" class="table-col">
        <b-table
          ref="table"
          id="my-table"
          :fields="fields"
          :busy.sync="isLoading"
          :items="myProvider"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
        >
          age
          <template v-slot:cell(created_date)="data">{{age(data.item.created_date)}}</template>
          <template v-slot:cell(actions)="data" v-if="developer == 1">
            <b-button
              type="button"
              class="mr-2"
              size="sm"
              variant="primary"
              @click="showEditModal(data)"
            >
              <font-awesome-icon
                v-b-tooltip.hover
                title="Edit User"
                class="text-light"
                icon="edit"
              />
            </b-button>
            <!-- <b-button
            size="sm"
              class="mr-1"
              append
              variant="outline-primary"
              :to="'/client-profile/'+data.item.id+'/overview'"
            >
              <font-awesome-icon icon="eye" />
            </b-button> -->
            <b-button
              size="sm"
              class="mr-1"
              append
              variant="outline-warning"
              :to="'/pri-client-profile/'+data.item.id+'/configuration'"
            >
              <font-awesome-icon icon="edit" />
            </b-button>
     
            <!-- <b-button
              @click="showFormStats(data)"
              :to="'/management-reports/'+data.item.id"
              append
              size="sm"
              class="mr-2"
              variant="outline-dark"
            >
              <font-awesome-icon icon="chart-line" />
            </b-button> -->
          </template>
        </b-table>
        <p class="mt-3">Current Page: {{ perPage }} rows</p>
        <b-row>
          <b-col cols="2">
            <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
          </b-col>
          <b-col>
            <b-pagination
              class="float-right"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
      <!-- secont col -->
    </b-row>
    <!-- Add Company Modal Component -->
    <div>
      <AddCompanyForm />
    </div>
    <!-- Edit Company Modal Component -->
    <div>
      <EditCompanyForm />
    </div>
  </b-container>
</template>

<script>
import { HTTP } from "../utils/HTTP";
import moment from "moment";
import AddCompanyForm from "@/components/clients/addCompanyForm";
import EditCompanyForm from "@/components/clients/editCompanyForm.vue";
import { EventBus } from "@/event-bus.js";

export default {
  name: "PriClientsView",
  components: {
    AddCompanyForm,
    EditCompanyForm
  },
  data() {
    return {  
      developer:false,
      values: {},
      totalRows: 0,
      isLoading: false,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 100],
      fields: [
        {
          key: "id",
          label: "Id",
          sortable: true
        },
        {
          key: "created_date",
          label: "Created",
          sortable: true
        },
        {
          key: "company_name",
          label: "Company Name",
          sortable: true
        },
        {
          key: "contact_name",
          label: "Contact Name",
          sortable: true
        },
        {
          key: "actions",
          label: "Actions"
        }
      ]
    };
  },

  computed: {
    rows() {
      return this.totalRows;
    }
  },
  mounted() {
    this.developer = process.env.VUE_APP_DEVEVLOPER_ONLY;
  },
  methods: {
    showAddModal() {
      EventBus.$emit("onShowAddModal", "");
    },
    showEditModal(data) {
      EventBus.$emit("onShowEditModal", data.item);
    },
    age(value) {
      let localeData = moment.updateLocale("en", {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "hello, a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        }
      });
      //return moment(value).fromNow();

      return moment(value).fromNow();
    },
    async myProvider() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage
      };

      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = HTTP("post", "v1/getclients", formData, {
        Authorization: token
      });
      return result
        .then(response => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [];
        });
    },
    itemAction(action, data, route) {
      window.location = route;
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    },
    showFormStats(data){
      // console.log("data", data.item.id)
      localStorage.setItem("companyId", data.item.id)
    }
  }
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.table-col {
  max-height: calc(100vh - 140px);
  overflow-y: scroll;
}

.pagination {
  margin-top: 0;
}

.btn.btn-border {
  border: 1px solid;
  margin-right: 2px;
}

.vuetable-pagination-info {
  margin-top: 8px !important;
}

span.sort-icon {
  float: right;
  color: #ff9100;
}
</style>
